import { Component, Input, Output, OnDestroy, OnInit, EventEmitter } from '@angular/core';
import { CsvService, JobsService } from 'core/services';
import { Subscription } from 'rxjs';

@Component({
  selector: 'lms-job-notifications-messages',
  templateUrl: './job-notifications-messages.component.html',
  styleUrls: ['./job-notifications-messages.component.scss']
})
export class JobNotificationsMessagesComponent implements OnInit, OnDestroy {
  @Input() jobId: string;
  @Output() public downloadErrors: EventEmitter<Object> = new EventEmitter<Object>();
  @Output() public navUrl?: EventEmitter<Object> = new EventEmitter<Object>();
  public percent: number = 0;
  public errors: any;
  public fatalError: any;
  public success: boolean = false;
  public progress: boolean = true;
  public notificationType: string;
  public fileUrl = '';
  public notificationUrl: string = '';
  public hasToReEnroll: boolean;
  public enrolledStudentsCount = 0;
  public reEnrolledStudentsCount = 0;
  public notReEnrolledStudentsCount = 0;
  public reEnrolledStudents: any;
  public notReEnrolledStudents: any;
  public erroredStudentsCount = 0;
  public isEnrollment = false;
  public enrollButton: string;
  public updated: number;
  public errored: number;
  public total: number;

  jobSubscription: Subscription;

  constructor(public jobsService: JobsService, public csvService: CsvService) {}

  ngOnInit() {
    this.jobSubscription = this.jobsService.getJobInfo$(this.jobId).subscribe((jobInfo) => {
      this.manageNotifications(jobInfo);
    });
  }

  ngOnDestroy(): void {
    this.jobSubscription.unsubscribe();
  }

  removeProgress() {
    this.progress = false;
  }

  removeFinished() {
    this.success = false;
    this.jobsService.deleteJob(this.jobId);
  }

  removeError() {
    this.errors = false;
    if (!this.success) {
      this.jobsService.deleteJob(this.jobId);
    }
  }

  removeFatalError() {
    this.fatalError = false;
    this.jobsService.deleteJob(this.jobId);
  }

  downloadCSV(errors) {
    this.downloadErrors.emit({ errors, type: this.notificationType });
  }

  /**
   * Emit the url for the navigation
   */
  public navUrlEmit(): void {
    this.navUrl.emit({ url: this.notificationUrl, type: this.notificationType });
  }

  manageNotifications(notification) {
    this.notificationType = notification.type;
    this.percent = notification.progress || 0;
    if (notification.status === 'finished') {
      if (this.jobsService.fileJobsResult.includes(this.notificationType)) {
        this.fileUrl = notification.details.summary.fileUrl;
      } else if (this.jobsService.navJobResult.includes(this.notificationType)) {
        this.notificationUrl = notification.details.summary?.navUrl;
      }
      this.progress = false;
      this.errors = notification.details.errors;
      this.updated = notification.details.summary.updated || 0;
      this.errored = notification.details.summary.errored || 0;
      this.total = this.updated + this.errored;
      this.success =
        !notification.details.summary.errored ||
        notification.details.summary.created > 0 ||
        notification.details.summary.updated > 0;

      // TODO: Refactor Coupled code
      if (notification.details?.reEnrolled || notification.details?.notReEnrolled) {
        this.isEnrollment = notification.details.reEnrolled || notification.details.notReEnrolled;
        this.hasToReEnroll = notification.details.summary.hasToReEnroll;
        this.erroredStudentsCount = notification.details.summary.errored;
        this.enrolledStudentsCount = notification.details.summary.created;

        if (this.hasToReEnroll) {
          this.reEnrolledStudents = notification.details.reEnrolled.list;
          this.reEnrolledStudentsCount = notification.details.reEnrolled.count || 0;
          this.enrollButton = 'reEnrolledButton';
        } else {
          this.notReEnrolledStudents = notification.details.notReEnrolled.list;
          this.notReEnrolledStudentsCount = notification.details.notReEnrolled.count || 0;
          this.enrollButton = 'notReEnrolledButton';
        }
      }
    } else if (notification.status === 'fatal-error') {
      this.fatalError = notification?.details?.errors || true;
      this.progress = false;
    }
  }

  getEmailMessage() {
    let message = '';
    if (this.total === this.errored) {
      message = 'fatalErrorTitle';
    } else if (this.errored) {
      message = 'errorTitle';
    } else {
      message = 'successTitle';
    }
    return message;
  }

  get messageLabel(): string {
    return this.jobsService.jobTypes[this.notificationType]?.toLowerCase();
  }

  get isEmailNotification(): boolean {
    return this.notificationType === this.jobsService.jobTypes.CHANGE_USER_EMAIL_BATCH;
  }
}
